import forEach from 'lodash/forEach'
import _replace from 'lodash/replace'
import { addToasty } from 'services/toasty/actions'
import { setPortalPlaylistData } from 'services/portal/actions'
import { getPrimary } from 'services/languages'
import { getNodes } from 'services/node'
import {
  getPlaylistItem,
  updatePlaylist,
  updatePlaylistItem,
  PLAYLIST_PORTAL_LIMIT,
} from './'
import {
  updatePlaylistItem as updateItem,
  PLAYLIST_UPDATED_ITEM,
  PLAYLIST_BATCH_UPDATE,
  PLAYLIST_UPDATE_ITEM,
  updatedPlaylistItem,
  PLAYLIST_GET_ITEM,
  PLAYLIST_UPDATE,
  setPlaylistItem,
} from './actions'

function getToastyMessage (text, added, error, isPortal, contentTitle = '') {
  /* eslint-disable no-template-curly-in-string */
  if (error) {
    if (added) {
      return isPortal
        ? _replace(text.get('addToPortalError'), '${ playlistPortalLimit }', PLAYLIST_PORTAL_LIMIT)
        : text.get('addToPlaylistError')
    }
    return isPortal
      ? text.get('removedFromPortalError')
      : text.get('removedFromPlaylistError')
  }
  if (added) {
    return isPortal
      ? text.get('addToPortalSuccess')
      : `${contentTitle} ${text.get('addedToYourPlaylist')}`
  }
  return isPortal
    ? text.get('removedFromPortalSuccess')
    : `${contentTitle} ${text.get('removedFromYourPlaylist')}`
}

function userIsLoggedIn ({ state }) {
  const { auth } = state

  return (
    auth.get('jwt')
  )
}

export function playlistAddToasty ({ after }) {
  return after(PLAYLIST_UPDATED_ITEM, async ({ action, state, dispatch }) => {
    const { payload } = action
    const { staticText, user, videos } = state
    const { error, type, add } = payload
    const text = staticText.getIn(['data', 'playlistAddRemove', 'data'])
    const languages = user.getIn(['data', 'language'])
    const userLanguage = getPrimary(languages)
    const videoTitle = videos.getIn([payload.contentId, userLanguage, 'data', 'title'])
    const message = getToastyMessage(text, add, error, type === 'portal', videoTitle)
    dispatch(addToasty(message))
  })
}

export function playlistGetItem ({ takeEvery }) {
  return takeEvery(PLAYLIST_GET_ITEM, async ({ action, state }) => {
    const { payload } = action
    const { auth, playlist } = state
    const { contentId, componentId } = payload
    const exists = playlist.getIn(['meta', contentId, 'data'])

    if (exists) {
      return setPlaylistItem({ componentId, contentId })
    }

    const data = await getPlaylistItem({ contentId, auth })
    return setPlaylistItem({ componentId, contentId, data })
  })
    .when(userIsLoggedIn)
    .catch(({ action }) => {
      const { payload } = action
      const { contentId } = payload
      return setPlaylistItem({
        error: true,
        contentId,
      })
    })
}

export function playlistUpdate ({ takeLatest }) {
  return takeLatest(PLAYLIST_UPDATE, async ({ action, state }) => {
    const { payload } = action
    const { auth } = state
    const { name } = payload
    // For now this is hardcoded for portals, but could be converted
    const { playlistName } = await updatePlaylist({ type: 'portal', name, auth })
    return setPortalPlaylistData({ playlistName })
  })
    .debounce(1000)
}

export function playlistUpdateItem ({ before }) {
  return before(PLAYLIST_UPDATE_ITEM, async ({ action, state, dispatch }) => {
    const { auth } = state
    const { payload } = action
    const { contentId, add, type } = payload
    await updatePlaylistItem({ contentId, type, auth, add })
    dispatch(updatedPlaylistItem({ contentId, type, add }))
  })
    .catch(({ action, dispatch }) => {
      const { payload } = action
      const { contentId, type, add } = payload
      dispatch(updatedPlaylistItem({
        error: true,
        contentId,
        type,
        add,
      }))
    })
}

export function playlistBatchUpdate ({ after }) {
  return after(PLAYLIST_BATCH_UPDATE, async ({ state, action, dispatch }) => {
    const { payload } = action
    const { auth, user } = state
    const { ids = [], type, add } = payload

    const languages = user.getIn(['data', 'language'])
    const nodes = await getNodes({
      language: getPrimary(languages),
      asTile: false,
      auth,
      ids,
    })

    forEach(nodes, async (node) => {
      if (node.nid && node.nid > 0) {
        dispatch(updateItem({
          contentId: node.nid,
          type,
          add,
        }))
      }
    })
  })
}
